import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';



@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient,  ) {}


  public getConfigUser(): Observable<any>{
    return this.http.get(urlApi+'/app/user/configuracoes', {headers: {'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token')?? ''}});
  }

  public getVersion(): Observable<any>{
    return this.http.post(`${urlApi}/app/version`,null)
  }
}
